// Third-party libraries
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { get } from 'lodash';

// Components
import ConnectedPrivateComponent from '@/views/components/PrivateComponent';
import { Button, MenuToggle } from '../buttons';

// Utilities
import { FormattedMessage } from '@/utils/i18n';

import { Action, ActionOptions, BasicInfo, EntityDetails, Pill } from '@/types/EntityDetails';

export const renderEntityBasicInfo = (entityBasicInfo?: BasicInfo[]) => {
  if (!entityBasicInfo) return [];
  return entityBasicInfo
    .filter(item => item.show)
    .map((data, index) => (
      <div key={`${index}-${data.className}`} className={`entity-field-basic-info ${data.className || ''}`}>
        <span className="ellipsis" data-private data-dd-privacy="mask">
          {data.value}
        </span>
      </div>
    ));
};

export const renderPills = (entityPills?: Pill[]) => {
  if (!entityPills) return [];
  return entityPills
    .filter(pill => pill.show)
    .map(pill => (
      <div key={pill.key} className="entity-field-basic-info">
        <span className="ellipsis" data-private data-dd-privacy="mask">
          {pill.value}
        </span>
      </div>
    ));
};

export const renderEntityInfoGrid = (entityDetails?: EntityDetails[]) => {
  if (!entityDetails) return [];
  return entityDetails
    .filter(data => data.show)
    .map(data => (
      <div key={data.key} className="entity-details-fields-group">
        <div className={`field ${data.optionalClassName || ''}`}>
          <span className="field-label">
            <FormattedMessage id={data.i18nPath} />
          </span>
          <span className="field-value ellipsis" data-private data-dd-privacy="mask">
            {data.value}
          </span>
        </div>
      </div>
    ));
};

export const renderDropdownActions = (options?: ActionOptions[]) => {
  if (!options) return null;
  return (
    <MenuToggle
      alignRight
      options={options.map((item, index) => (
        <Dropdown.Item key={index} role="menuitem" as="button" onClick={item.onClick} className={item.className || ''}>
          <i className={`icon-${item.icon}`} />
          {item.label}
        </Dropdown.Item>
      ))}
      dataTestId="entity-details-summary-dropdown"
    />
  );
};

export const renderActions = (actions?: Action[]) => {
  if (!actions) return [];
  return actions.map((action, index) => (
    <ConnectedPrivateComponent key={`${index}-${action.className}`} forcedFalse={action.forcedFalse} permissions={action.permissions}>
      {() =>
        get(action, 'options', []).length > 0 ? (
          renderDropdownActions(action.options)
        ) : (
          <Button className={action.className} onClick={action.onClick}>
            <FormattedMessage id={action.i18nPath!} />
          </Button>
        )
      }
    </ConnectedPrivateComponent>
  ));
};
